import { usePagination } from '@/hooks/usePagination';

export default function Steps() {
  const { currentIndex, totalSteps } = usePagination();

  return (
    <span className="text-sm/[26px] sm:text-sm/[22px] md:ml-0">
      Step: {currentIndex} of {totalSteps - 1}
    </span>
  );
}
